import { render } from "./OrgImage.vue?vue&type=template&id=e943d70e&scoped=true&ts=true"
import script from "./OrgImage.vue?vue&type=script&lang=ts"
export * from "./OrgImage.vue?vue&type=script&lang=ts"

import "./OrgImage.vue?vue&type=style&index=0&id=e943d70e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e943d70e"]])

export default __exports__